import { Component, Input, OnInit } from '@angular/core';
import { BreadcrumbService } from '../../services/breadcrumb/breadcrumb.service';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ScreenSizeService } from '../../services/screen-size/screen-size.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent implements OnInit {
  @Input() useRouter: boolean = false;
  breadcrumbs: any;
  screenSize?: string;

  constructor(private breadcrumbService: BreadcrumbService, private screenSizeService: ScreenSizeService) {
    this.breadcrumbService.breadcrumbs$.subscribe((breadcrumbs: any) => {
      this.breadcrumbs = breadcrumbs;
    });
  }

  ngOnInit(): void {
    this.screenSizeService.screenSize$.subscribe((size) => {
      this.screenSize = size;
    });
  }
}
